import { RootState } from "../../rootReducer";

export const selectIsLoadingMiniStress = (state: RootState) =>
  state.sendMiniStressNotification.loading;
export const selectIsSavedMiniStress = (state: RootState) =>
  state.sendMiniStressNotification.saved;
export const selectMiniStressNotiErrorMessage = (state: RootState) =>
  state.sendMiniStressNotification.error;
export const sendMiniStressNotificationDataResponse = (state: RootState) =>
  state.sendMiniStressNotification.sendMiniStressNotificationResponse;
